module.exports = __webpack_public_path__ + "img/9.af7811dc.jpg";